class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-notification").deleteQuantity(
        this.dataset.index,
        0,
        "remove",
        this.dataset.key
      );
      this.closest(".cart-notification-product").classList.add("loading");
      this.closest(
        ".cart-notification-product"
      ).firstElementChild.classList.remove("hidden");
      document.getElementById('offcanvas__mini_cart').classList.add('loading-bar');
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.cartItemConatiner = document.getElementById(
      "cart-notification-product"
    );
 
    this.emptyCartItem = document.getElementById("min-cart-items");
    this.cartItemMessageShow = document.querySelector(".empty__cart__item");
    this.emptyCartButtonDisable = document.getElementById("empty__cart__button");
    this.emptyCartHeader =  document.querySelector(".cart-notification__header"); 

    this.cartAddSuccess = document.querySelector(".item__success_message ");
    this.cartEmptyHead = document.querySelector(".item__empty_message");

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.querySelectorAll('.cart-notification__close').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
    this.querySelector('#hd-continue-shopping')?.addEventListener('click', () => this.continueShopping());

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.quantityUpdateInProgress = false;
    this.addEventListener("change", this.onChange.bind(this));
    this.addEventListener("click", this.onCartClick.bind(this));
    this.syncFreeShippingProgress();
  }

  onCartClick(event) {
    const toggle = event.target.closest("[data-hd-cart-complementary-toggle]");
    if (!toggle || !this.contains(toggle)) return;

    const wrapper = toggle.closest("[data-hd-cart-complementary]");
    const panel = wrapper?.querySelector("[data-hd-cart-complementary-output]");
    if (!panel) return;

    const expanded = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!expanded));
    panel.hidden = expanded;
  }

  syncFreeShippingProgress() {
    const mount = this.querySelector("[data-hd-cart-free-shipping-mount]");
    const source = this.querySelector("#hedera-cart-complementary-source .hd-cart-free-shipping--top");
    if (!mount) return;
    mount.replaceChildren();
    if (source) mount.appendChild(source);
  }

  onChange(event) {
    const quantityInput = event.target.closest('input[name="updates[]"]');
    if (!quantityInput || this.quantityUpdateInProgress) return;

    const maximum = quantityInput.max === "" ? null : Number(quantityInput.max);
    let requestedQuantity = Number.parseInt(quantityInput.value, 10);
    if (!Number.isFinite(requestedQuantity)) {
      quantityInput.value = quantityInput.dataset.currentQuantity || "1";
      return;
    }

    requestedQuantity = Math.max(0, requestedQuantity);
    if (Number.isFinite(maximum)) requestedQuantity = Math.min(requestedQuantity, maximum);
    quantityInput.value = requestedQuantity;

    if (requestedQuantity === Number.parseInt(quantityInput.dataset.currentQuantity, 10)) return;

    const activeElementName = document.activeElement
      ? document.activeElement.getAttribute("name")
      : null;

    this.updateQuantity(
      quantityInput.dataset.index,
      requestedQuantity,
      activeElementName,
      quantityInput.dataset.key,
      quantityInput
    );
  }

  setQuantityBusy(isBusy) {
    this.quantityUpdateInProgress = isBusy;
    this.toggleAttribute("aria-busy", isBusy);

    if (isBusy) {
      this.querySelectorAll(
        '.quantity__button:not(:disabled), .quantity__input:not(:disabled), .hd-cart-item__remove:not(:disabled)'
      ).forEach((control) => {
        control.dataset.hdQuantityBusyDisabled = "true";
        control.disabled = true;
      });
    } else {
      this.querySelectorAll('[data-hd-quantity-busy-disabled="true"]').forEach((control) => {
        control.disabled = false;
        delete control.dataset.hdQuantityBusyDisabled;
      });
    }

    document.querySelector(".cart_action_drawer_overlay")?.classList.toggle("active", isBusy);
    this.notification.classList.toggle("loading-bar", isBusy);
  }

  showLineError(line, message) {
    const errorRegion = document.getElementById(`Line-item-error-${line}`);
    const errorText = errorRegion?.querySelector(".cart-item__error-text");
    if (!errorRegion || !errorText) return;
    errorText.textContent = message;
    errorRegion.classList.remove("no-js-inline");
  }

  hideLineError(line) {
    const errorRegion = document.getElementById(`Line-item-error-${line}`);
    if (!errorRegion) return;
    errorRegion.classList.add("no-js-inline");
  }

  open() {
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");
    this.loadComplementaryRecommendations();

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClick);

  }

  continueShopping() {
    this.close();
    if (!/\/cart\/?$/.test(window.location.pathname)) return;

    let destination;
    try {
      destination = new URL(sessionStorage.getItem('hd_last_page') || '', window.location.href);
    } catch (_) {
      destination = null;
    }

    if (!destination || destination.origin !== window.location.origin || /\/(cart|checkout)\/?$/.test(destination.pathname)) {
      destination = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
    }

    if (destination.pathname === window.location.pathname && destination.search === window.location.search) {
      return;
    }

    window.setTimeout(() => window.location.assign(destination.href),
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      let renderSelector = document.getElementById(section.id);
      const sectionHTML = parsedState.sections && parsedState.sections[section.id];
      if (renderSelector && sectionHTML) {
        renderSelector.innerHTML = this.getSectionInnerHTML(sectionHTML);
      }
    });
    this.syncFreeShippingProgress();

    const countSectionHTML = parsedState.sections && parsedState.sections["cart-notification-count"];
    const sectionItemCount = parseInt(this.getSectionInnerHTML(countSectionHTML), 10);
    const cartItemCount = Number.isFinite(parsedState.item_count)
      ? parsedState.item_count
      : sectionItemCount;

    const itemsCount = this.querySelector("[data-hd-cart-items-count]");
    if (itemsCount && Number.isFinite(cartItemCount)) {
      itemsCount.textContent = `(${cartItemCount})`;
      itemsCount.setAttribute("aria-label", window.hederaUiText("items_label", { count: cartItemCount }));
    }

    const headingCount = this.querySelector("[data-hd-cart-heading-count]");
    if (headingCount && Number.isFinite(cartItemCount)) {
      headingCount.textContent = cartItemCount > 0
        ? window.hederaUiText(cartItemCount === 1 ? "product_one" : "product_other", { count: cartItemCount })
        : "";
    }

    if (Number.isFinite(cartItemCount)) {
      document.querySelectorAll('[id="cart-notification-count"]').forEach((countNode) => {
        countNode.textContent = cartItemCount;
      });
      document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach((labelNode) => {
        labelNode.textContent = window.hederaUiText("cart_count", { count: cartItemCount });
      });
    }

    if (Number.isFinite(cartItemCount)) this.currentItemCount = cartItemCount;

    //console.log(cartItemCount);

    if (cartItemCount == 0) {
      this.emptyCartItem.classList.add("no-js-inline");
      this.emptyCartButtonDisable.classList.add("no-js-inline");
      this.cartItemMessageShow.classList.remove("no-js-inline");
      this.cartAddSuccess.classList.add("no-js-inline");
      this.cartEmptyHead.classList.add("no-js-inline");
       this.emptyCartHeader.classList.add('empty__cart');
    } else {
      this.emptyCartItem.classList.remove("no-js-inline");
      this.emptyCartButtonDisable.classList.remove("no-js-inline");
      this.cartItemMessageShow.classList.add("no-js-inline");
      this.cartAddSuccess.classList.remove("no-js-inline");
      this.cartEmptyHead.classList.remove("no-js-inline");
      this.emptyCartHeader.classList.remove('empty__cart');
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
      },
      {
        id: "cart-notification-subtotal",
      },
      {
        id: "cart-notification-count",
      },
      {
        id: "cart-notification-discount"
      },
      {
        id: "hedera-cart-complementary-source"
      }
    ];
  }

  async loadComplementaryRecommendations() {
    const wrapper = this.querySelector("[data-hd-cart-complementary]");
    if (!wrapper) {
      if (this.complementaryAbortController) this.complementaryAbortController.abort();
      return;
    }
    if (wrapper.dataset.loaded === "true") return;

    const output = wrapper.querySelector("[data-hd-cart-complementary-output]");
    const sourceIds = (wrapper.dataset.productIds || "").split(",").filter(Boolean);
    const cartIds = new Set((wrapper.dataset.cartProductIds || "").split(",").filter(Boolean));
    const limit = Math.max(1, parseInt(wrapper.dataset.limit || "2", 10));
    const recommendationsUrl = wrapper.dataset.recommendationsUrl || "/recommendations/products";

    if (!output || sourceIds.length === 0) return;

    if (this.complementaryAbortController) this.complementaryAbortController.abort();
    this.complementaryAbortController = new AbortController();
    const signal = this.complementaryAbortController.signal;
    const selectedIds = new Set();
    const selectedCards = [];

    const collectCards = (html) => {
      const parsed = new DOMParser().parseFromString(html, "text/html");
      parsed.querySelectorAll("[data-hd-recommendation-card]").forEach((card) => {
        const productId = card.dataset.productId;
        if (
          selectedCards.length < limit &&
          productId &&
          !cartIds.has(productId) &&
          !selectedIds.has(productId)
        ) {
          selectedIds.add(productId);
          selectedCards.push(card);
        }
      });
    };

    try {
      for (const productId of sourceIds) {
        if (selectedCards.length >= limit) break;
        const url = `${recommendationsUrl}?section_id=hedera-cart-complementary&product_id=${encodeURIComponent(productId)}&limit=10&intent=complementary`;
        const response = await fetch(url, { signal });
        if (response.ok) collectCards(await response.text());
      }

      if (selectedCards.length === 0 && wrapper.dataset.fallbackHandle) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
        const separator = root.includes("?") ? "&" : "?";
        const response = await fetch(`${root}${separator}section_id=hedera-cart-complementary-fallback`, { signal });
        if (response.ok) collectCards(await response.text());
      }

      if (selectedCards.length > 0) {
        output.replaceChildren(...selectedCards);
        output.hidden = true;
        wrapper.querySelector("[data-hd-cart-complementary-toggle]")?.setAttribute("aria-expanded", "false");
        wrapper.hidden = false;
      } else {
        output.replaceChildren();
        output.hidden = true;
        wrapper.hidden = true;
      }
      wrapper.dataset.loaded = "true";
    } catch (error) {
      if (error.name !== "AbortError") console.error("Hedera complementary recommendations:", error);
      wrapper.hidden = true;
    }
  }

  async updateQuantity(line, quantity, name, itemKey, quantityInput) {
    if (this.quantityUpdateInProgress) return;

    const requestedQuantity = Number.parseInt(quantity, 10);
    if (!Number.isFinite(requestedQuantity)) return;

    const body = JSON.stringify({
      ...(itemKey ? { id: itemKey } : { line }),
      quantity: requestedQuantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    this.setQuantityBusy(true);

    try {
      const response = await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        body,
      });
      const parsedState = await response.json();

      if (!response.ok || !parsedState.sections) {
        throw new Error(
          window.hederaTranslateCartError(
            parsedState.description || parsedState.message
          )
        );
      }

      this.renderContents(parsedState);
      this.updateLiveRegions(line, requestedQuantity, parsedState, itemKey);

      if (requestedQuantity > 0 && name) {
        const updatedInput = document.getElementById(`Quantity-${line}`);
        updatedInput?.closest("quantity-input")?.querySelector(`[name="${name}"]`)?.focus();
      }
    } catch (error) {
      if (quantityInput?.isConnected) {
        quantityInput.value = quantityInput.dataset.currentQuantity || quantityInput.value;
      }
      const failedItem = document
        .getElementById(`Remove-${line}`)
        ?.closest(".cart-notification-product");
      failedItem?.classList.remove("loading");
      failedItem?.querySelector(".loading-overlay")?.classList.add("hidden");
      this.showLineError(line, error.message || window.cartStrings.error);
      console.error("Hedera cart quantity update:", error);
    } finally {
      this.setQuantityBusy(false);
    }
  }
  updateLiveRegions(line, requestedQuantity, parsedState, itemKey) {
    const items = Array.isArray(parsedState.items) ? parsedState.items : [];
    const lineIndex = Number.parseInt(line, 10) - 1;
    const actualItem =
      (itemKey ? items.find((item) => item.key === itemKey) : null) ||
      (Number.isInteger(lineIndex) && lineIndex >= 0 ? items[lineIndex] : null);
    const actualQuantity = actualItem ? Number(actualItem.quantity) : NaN;

    if (
      requestedQuantity > 0 &&
      Number.isFinite(actualQuantity) &&
      actualQuantity !== requestedQuantity
    ) {
      this.showLineError(
        line,
        window.cartStrings.quantityError.replace("[quantity]", actualQuantity)
      );
    } else {
      this.hideLineError(line);
    }

    if (Number.isFinite(parsedState.item_count)) {
      this.currentItemCount = parsedState.item_count;
    }
  }
  deleteQuantity(line, quantity, name, itemKey) {
    return this.updateQuantity(line, quantity, name, itemKey);
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const section = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    return section ? section.innerHTML : "";
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.miniCartClose()
    );
  }

  onClickMiniCart() {
    document
      .getElementById("offcanvas__mini_cart")
      .classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");
    const cartNotification = document.querySelector("cart-notification");
    if (cartNotification && typeof cartNotification.loadComplementaryRecommendations === "function") {
      cartNotification.loadComplementaryRecommendations();
    }

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClassRemove);
  }

  miniCartClose() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClassRemove);
    removeTrapFocus(document.querySelector(".header__actions_btn--cart"));
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    //console.log(eventTarget);
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);
